<template>
  <div :class="$style.ctn">
    <ul :class="$style.list">
      <li v-for="spec in specs" :key="spec.key" :class="$style.li">
        <i :class="$style.icon">
          <SvgIcon
            :class="$style.indicator"
            height="100%"
            :src="`icon-sprite-indicators.svg#${spec.key}`"
          />
        </i>
        <span :class="$style.text">{{ spec.desc }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

import specs from '../common/specs';
import SvgIcon from './SvgIcon.vue';

export default defineComponent({
  components: { SvgIcon },
  data: () => ({
    specs,
  }),
});
</script>

<style lang="scss" module>
.ctn {
  padding: 15px 10px;
}
.list {
  list-style: none;
  display: grid;
  grid-gap: 8px 40px;
  flex-wrap: wrap;
  grid-template-columns: repeat(4, 1fr);
}
.li {
  display: flex;
  grid-auto-flow: column;
  align-items: center;
  padding-left: 14px;

  &:nth-last-child(n + 5) {
    padding-bottom: 8px;
    border-bottom: 1px solid #e0eaf2;
  }
}
.icon {
  display: block;
  flex: none;

  &,
  svg {
    width: 26px;
    height: 26px;
  }
  & + * {
    margin-left: 14px;
  }
}
.text {
  font-size: 12px;
  color: #2f3543;
}
</style>
